import { AbstractControl, FormControlState } from "@angular/forms";
import {concat, defer, distinctUntilChanged, map, Observable, of} from "rxjs";

function isState<T>(value: T | FormControlState<T>): value is FormControlState<T> {
  return (value as FormControlState<T>)?.value !== undefined;
}

export function fromFormControl<T>(control: AbstractControl<T | FormControlState<T>>): Observable<T> {
    return concat(
        defer(() => of(control.value)),
        control.valueChanges
    ).pipe(
        map(value => {
            if (isState(value))
                return value.value;
            else
                return value;
        }),
        distinctUntilChanged());
}
